import InmuebleFacturasTemplate from "../../components/templates/inmuebles/InmuebleFacturasTemplate";

const InmuebleFacturas = () => {
    return <InmuebleFacturasTemplate/>;
};

export default InmuebleFacturas;